<template>
  <div class="storage-body">
    <img src="@/assets/storage.png" />
  </div>
</template>

<script>
export default {
  created() {
    document.title='成熟后储存方法'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.storage-body {
  max-width: 750px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0;
}
.storage-body img {width: 100%}
</style>



// WEBPACK FOOTER //
// src/components/page/storage.vue